import "../../../../NodeTypes/index";

window.addEventListener('DOMContentLoaded', () => {
  handleMargin();
  window.addEventListener('resize', debounce(handleMargin, 200));
});

function debounce(func, delay) {
  let debounceTimer;

  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}

function handleMargin() {
  const mainContent = document.querySelector('#main-header .header-content');
  if (!mainContent) return;

  const rect = mainContent.getBoundingClientRect();
  const leftOffset = rect.left;

  document.body.style.setProperty('--main-content-margin-left', `${leftOffset}px`);
}
